import type { BaziDetail } from '@/utils/lunarCalendar';

export interface DestinyRecord {
  id: string;
  solarDate: string;
  lunarDate: string;
  zodiac: string;
  pillars: {
    year: string;
    month: string;
    day: string;
    hour: string;
  };
  dayStem: string;
  dayStemWuxing: string;
  aiReading: string;
  createdAt: number;
}

const STORAGE_KEY = 'iching_destiny_records';

export function saveDestinyRecord(record: Omit<DestinyRecord, 'id' | 'createdAt'>): DestinyRecord {
  const newRecord: DestinyRecord = {
    ...record,
    id: `destiny_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    createdAt: Date.now(),
  };

  const existing = getDestinyRecords();
  const updated = [newRecord, ...existing].slice(0, 30);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  return newRecord;
}

export function getDestinyRecords(): DestinyRecord[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function deleteDestinyRecord(id: string): void {
  const existing = getDestinyRecords();
  const updated = existing.filter((r) => r.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
}

export function clearAllDestinyRecords(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function formatDestinyDate(timestamp: number): string {
  const d = new Date(timestamp);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hour = String(d.getHours()).padStart(2, '0');
  const minute = String(d.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:${minute}`;
}